import { BoxLogo, BrandfolderLogo, Dropbox as DropboxIcon, GoogleDrive, SharePointIcon } from '@air/next-icons';
import { cn } from '@air/utils-tailwind';

export type ImportIconProps = {
  isActive: boolean;
  className?: string;
};

const sourceImageClassName = 'mr-2.5 text-grey-9 w-6 h-6';

export const GoogleDriveImportIcon = ({ isActive, className }: ImportIconProps) => {
  return <GoogleDrive className={cn(sourceImageClassName, isActive ? '' : '[&>path]:fill-grey-9', className)} />;
};

export const DropboxImportIcon = ({ isActive, className }: ImportIconProps) => {
  return <DropboxIcon className={cn(sourceImageClassName, isActive ? 'text-[#0061FF]' : '', className)} />;
};

export const HomeBoxImportIcon = ({ isActive, className }: ImportIconProps) => {
  return <BoxLogo className={cn(sourceImageClassName, isActive ? 'text-[#0061FF]' : '', className)} />;
};

export const BrandfolderImportIcon = ({ isActive, className }: ImportIconProps) => {
  return <BrandfolderLogo className={cn(sourceImageClassName, isActive ? 'text-[#0061FF]' : '', className)} />;
};

export const SharePointImportIcon = ({ isActive, className }: ImportIconProps) => {
  return <SharePointIcon className={cn(sourceImageClassName, isActive ? '' : 'opacity-60 grayscale', className)} />;
};
